import React from 'react';
import dynamic from 'next/dynamic';

import { useRouter } from 'next/router';

import { QUERY_PARAMS } from '@constants/query-params';
import { useModalDispatchHelpers } from '@context/ModalContext';
import { MODAL_TYPES } from '@helpers/LayoutHelpers';
import { addQueryParams } from '@helpers/UrlHelpers';
import { useUser } from '@hooks/data/useUser';

const EmagGenius = dynamic(() => import('@components/genius/EmagGenius/EmagGenius'), { ssr: false });

interface Props {
  isMobilePreview?: boolean
}

const EmagGeniusTemplate = (props: Props) => {
  const { isMobilePreview } = props;

  // Hooks

  const router = useRouter();

  const { showModal, hideModal } = useModalDispatchHelpers();

  const { data: user } = useUser({ isOptional: true });

  const { isGeniusEligible3M10 } = user || {};

  // Effects

  React.useEffect(() => {
    if (isGeniusEligible3M10) {
      if (isMobilePreview) {
        addQueryParams(router, { [QUERY_PARAMS.GENIUS_TRIAL_3M]: true });
      } else {
        showModal(
          MODAL_TYPES.GENIUS_TRIAL,
          {
            handleModalClose: () => {
              hideModal();
            }
          }
        );
      }
    }
  }, [isGeniusEligible3M10]);

  // Render

  return (
    <EmagGenius
      id="emag-genius-dashboard"
    />
  );
};

export default EmagGeniusTemplate;
